import React from 'react'
import ReactDOM from 'react-dom'
import {BrowserRouter} from 'react-router-dom'
import injectTapEventPlugin from 'react-tap-event-plugin'
import {MuiThemeProvider, createMuiTheme} from '@material-ui/core/styles'
import cyan from '@material-ui/core/colors/cyan'
import pink from '@material-ui/core/colors/pink'
import grey from '@material-ui/core/colors/grey'
import ReactGA from 'react-ga'
import App from './App'
import registerServiceWorker from './registerServiceWorker'

injectTapEventPlugin()

const theme = createMuiTheme({
  palette: {
    primary: {
      light: cyan[100],
      main: cyan[700],
      dark: cyan[700],
      contrastText: 'white',
    },
    secondary: {
      light: grey[400],
      main: grey[800],
      dark: grey[900],
      selected: pink[500],
      contrastText: 'white',
    },
    bg: {
      dark: {
        main: grey[800],
        text: 'white',
      },
      light: {
        main: grey[200],
        text: grey[600],
      },
      black: {
        main: grey[900],
        text: grey[500],
      }
    },
  },
})

ReactDOM.render((
  <BrowserRouter>
    <MuiThemeProvider theme={theme}>
      <App />
    </MuiThemeProvider>
  </BrowserRouter>
), document.getElementById('root'))
registerServiceWorker()

ReactGA.initialize('UA-52087457-20')
ReactGA.pageview(window.location.pathname + window.location.search)



// WEBPACK FOOTER //
// ./src/index.js